<template>
  <div class="main-wrapper">
    <div class="content">
      <div class="scrollable-content">
        <div class="scrollable-content--width">
          <div class="introduction-intro">
            <div class="introduction-intro-content">
              <h2 class="light-header">Introduction</h2>
              <h1>Retirement Outcomes Evaluator</h1>
              <div class="btn-wrap">
                <button class="btn-primary" @click="nextAction">Start</button>
                <button class="btn-secondary" v-scroll-to="'#firstSection'">
                  View more
                </button>
              </div>
            </div>
          </div>

          <section class="introduction-desc" id="firstSection">
            <div class="section-header">
              <h2>
                This service has three important benefits to you as the Plan
                Sponsor
              </h2>
            </div>
            <div class="section-content">
              <div class="col-grid">
                <div class="col">
                  <div class="research-providers">
                    <img src="@/assets/ico/ico-introduction-1.svg" alt="" />
                    <p>
                      As the Fiduciary for the plan, you are required to always
                      act in the best interest of plan participants and
                      beneficiaries. Improving Retirement Outcomes is completely
                      aligned with that responsibility and research has shown
                      that employees who are less worried about their financial
                      future are in fact more engaged and more productive.
                    </p>
                  </div>
                </div>
                <div class="col">
                  <div class="research-providers">
                    <img src="@/assets/ico/ico-introduction-2.svg" alt="" />
                    <p>
                      Improving the Retirement Outcomes of your plan should
                      provide greater protection for you as the Responsible Plan
                      Fiduciary. In this regard, the Retirement Outcomes
                      Evaluator is designed to improve the Retirement Outcomes
                      of your participants
                      <span class="bold"
                        >without negatively impacting your P&L.</span
                      >
                    </p>
                  </div>
                </div>
                <div class="col">
                  <div class="research-providers">
                    <img src="@/assets/ico/ico-introduction-3.svg" alt="" />
                    <p>
                      As an executive or business owner, you should know that if
                      employees cannot retire comfortably, they will continue
                      working. Long term, this can lead to higher benefit costs,
                      higher absenteeism costs and lower work productivity. All
                      of which are not helpful to your P&L.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section class="introduction-step-section">
            <div class="section-header">
              <h2>
                This service accomplishes all of the above by following a simple
                5-step process
              </h2>
            </div>
            <div class="section-content">
              <div class="introduction-step">
                <div class="introduction-step-pic">
                  <img src="@/assets/img/bg/step-1.jpg" alt="" />
                </div>
                <div class="introduction-step-desc">
                  <h2 class="light-active-header">STEP 1</h2>
                  <h5>Independent Research provides insight</h5>
                  <p>
                    Fiduciary Benchmarks is constantly examining newly published
                    industry research. We use our knowledge and experience to
                    identify key points and provide access to the research that
                    may support changes to your plan or participant behavior in
                    an independent and unbiased manner.
                  </p>
                </div>
              </div>

              <div class="introduction-step">
                <div class="introduction-step-pic">
                  <img src="@/assets/img/bg/step-2.jpg" alt="" />
                </div>
                <div class="introduction-step-desc">
                  <h2 class="light-active-header">STEP 2</h2>
                  <h5>Behavioral Finance Tools generate results</h5>
                  <p>
                    Fiduciary Benchmarks then presents plan design tools and
                    services based on solid research that have been PROVEN to
                    improve the Saving Behavior, Investing Behavior or Spending
                    Behavior of your participants.
                  </p>
                </div>
              </div>

              <div class="introduction-step">
                <div class="introduction-step-pic">
                  <img src="@/assets/img/bg/step-3.jpg" alt="" />
                </div>
                <div class="introduction-step-desc">
                  <h2 class="light-active-header">STEP 3</h2>
                  <h5>Lead Indicators track participant behavior</h5>
                  <p>
                    Fiduciary Benchmarks then tracks EACH YEAR the changes in
                    behavior we EXPECT from your participants and compares them
                    to applicable industry benchmarks or other metrics that will
                    PREDICT better Retirement Outcomes (this is why they are
                    called Lead Indicators).
                  </p>
                </div>
              </div>

              <div class="introduction-step">
                <div class="introduction-step-pic">
                  <img src="@/assets/img/bg/step-4.jpg" alt="" />
                </div>
                <div class="introduction-step-desc">
                  <h2 class="light-active-header">STEP 4</h2>
                  <h5>Lag Indicators show impact on Retirement Outcomes</h5>
                  <p>
                    Fiduciary Benchmarks will also track EACH YEAR how the Lead
                    Indicators ACTUALLY RESULT in greater Retirement Outcomes in
                    terms of increased account balances at retirement as well as
                    increases in Wage Replacement Ratios (these are called Lag
                    Indicators).
                  </p>
                </div>
              </div>

              <div class="introduction-step">
                <div class="introduction-step-pic">
                  <img src="@/assets/img/bg/step-5.jpg" alt="" />
                </div>
                <div class="introduction-step-desc">
                  <h2 class="light-active-header">STEP 5</h2>
                  <h5>
                    Marginal Cost tracks potential issues for Plan Sponsors and
                    Participants
                  </h5>
                  <p>
                    Lastly, we realize there is a Marginal Cost to the
                    considerable Marginal Benefits of this service. Therefore,
                    Fiduciary Benchmarks tracks potential issues for you as the
                    Plan Sponsor and for your participants so you can quickly
                    and logically answer any questions caused by these changes.
                  </p>
                </div>
              </div>
            </div>
          </section>

          <div class="introduction-start">
            <h2>Try Retirement Outcomes Evaluator right now!</h2>
            <div class="btn-wrap">
              <button class="btn-primary" @click="nextAction">Start</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "RoeReportIntroduction",
  methods: {
    nextAction() {
      this.$router.push({
        name: "report-edit",
        params: {
          id: this.$router.currentRoute.params.id,
          step: "eligibility"
        }
      });
    }
  }
};
</script>
